export function toNumber(a: any) {
  return Number(a);
}
